import React, { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useReactiveVar } from '@apollo/client';

import { Form, IFormImperativeHandleProps } from '../../../../common/form';
import { ToggleButtonGroup } from '../../../../common/form/toggle-button-group';
import { useStyles } from './ecp-filters-modal-form.styles';
import { IEcpFiltersModalFormProps } from './ecp-filters-modal-form.models';
import {
  retailerShopTypeItems,
  shopTypeItems,
  specFilterItemsWithMyopia,
  specializationTypeFilteringItems,
} from '../filtering-criteria-items/filtering-criteria-items';
import { setMyopiaControl } from '../../../../../graphql/configuration/configuration.cache';
import { EcpServices } from '../../ecp-locator';

export const EcpFiltersModalForm = forwardRef<
IFormImperativeHandleProps, IEcpFiltersModalFormProps>(({
  defaultValues, onApplyFilters, ecpService,
}, ref): JSX.Element => {
  const classes = useStyles();
  const isMyopiaControl = useReactiveVar(setMyopiaControl);

  return (
    <Form
      ref={ref}
      defaultValues={defaultValues}
      onSubmit={onApplyFilters}
    >
      <h2 className={classes.filtersTypeTitle}>
        <FormattedMessage
          id="ecp.spec.additional.title"
        />
      </h2>
      <ToggleButtonGroup
        name="specializations"
        standalone
        size="small"
        variant="outlined"
        options={isMyopiaControl ? specFilterItemsWithMyopia : specializationTypeFilteringItems}
        buttonStyles={classes.buttonStyles}
      />
      <h2 className={classes.filtersTypeTitle}>
        <FormattedMessage
          id="ecp.filters.modal.shopType.title"
        />
      </h2>
      <ToggleButtonGroup
        name="shops"
        standalone
        size="small"
        variant="outlined"
        options={ecpService === EcpServices.buy ? retailerShopTypeItems : shopTypeItems}
        buttonStyles={classes.buttonStyles}
      />
    </Form>
  );
});
